/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable no-mixed-operators */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-dupe-class-members */
import { AfterViewInit, Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { messagesConfig } from 'src/app/shared/constants/message.constants';
import { UserService } from 'src/app/shared/services/user.service';
import { CustomDecimalValidator, ValidateOneDecimal } from 'src/app/shared/validators/one-decimal.validator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IMessage } from 'src/app/shared/models/message.modal';
import { MessageModalComponent } from 'src/app/shared/components/message-modal/message-modal.component';
import { MoistureWorkSheet,
  NativeSoilType,
  ReceivedMCWorkSheet,
  WorkSheet,
  ProctorSheet } from '../../models/native-soil-worksheet.modal';
import { NativeSoilService } from '../../services/native-soil/native-soil.service';
import { DateTimeUtils } from 'src/app/shared/util/date-time.utils';

@Component({
    selector: 'app-edit-native-soil-worksheet',
    templateUrl: './edit-native-soil-worksheet.component.html',
    styleUrls: ['./edit-native-soil-worksheet.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditNativeSoilWorksheetComponent implements OnInit, AfterViewInit{
  public inHouseIdDuplicateError = false;
  public titleError = false;
  workSheetType = '';
  public worksheets: NativeSoilType[];
  workSheet: NativeSoilType;
  currentIndex = 0;
  headerText: string | undefined = '';
  actionDone = 'CLOSED';
  nextActive = true;
  previousActive = false;
  currentIndexHandling = '0';
  changeDetected = false;
  saveActive = false;
  isEdit = false;
  title = '';
  modalType = '';
  isBulk = false;
  isForm = false;
  WTypeActive = {
    received: false,
    moisture: false,
    worksheet: false,
    proctor: false,
  };
  targertWetWeight = '';
  mc = '';

  dryPlusTareCheck = false;
  dryTrCheck = false;
  dryTrIntial = true;
  public selectedIndex = 0;
  enableOpenTechWorksheetButton = false;
  dryWetWeighterror = false;
  moistureInValid: boolean;
  asReceivedInComplete: boolean;
  moistureContentData: any;
  projectIdValue: any;
  public form: FormGroup = new FormGroup({
  });

  component: { id: string; depth: string; inHouseId: string; wetWeight: string; dryWeight: string; loss: string; moistureContent: string; status: string; compactionEffort: string; drySoil: string; addWater: string; multiPointMoisture: never[]; multiPointTests: never[]; reUse: false; parentRow: true; };
  weightChecked = false;
  userRoles: string[];
  constructor(
    private mdr: MatDialogRef<EditNativeSoilWorksheetComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private userService: UserService,
    private nativeSoilService: NativeSoilService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) {
    this.worksheets = data.worksheets;
    this.workSheetType = data.workSheetType;
    this.isForm = data.isForm;
    this.modalType = data.modalType;
    this.isBulk = data.isBulk;
    this.currentIndex = this.worksheets.findIndex((x: NativeSoilType) => x?.id === data.element.id);
    this.workSheet = this.worksheets[this.currentIndex];
    this.userRoles = data.role;
    const wLength = this.worksheets.length;
    if (this.currentIndex > 0) {
      this.previousActive = true;
    }
    if (this.currentIndex < wLength) {
      this.nextActive = true;
    }
    if (this.worksheets.length === 1 || this.currentIndex === wLength - 1) {
      this.nextActive = false;
    }
    this.viewData();

    this.setWTypeActive(this.workSheetType);
    this.title = data.title;
  }

  ngOnInit() {
    this.isEdit = this.roleCheck(['Manager', 'Labtech', 'Admin']);
    this.projectIdValue = this.workSheet?.projectId;
    if (this.workSheetType === 'workSheet') {
      this.getnativeSoilData();
      this.updateTabSelectionBasedOnForm();
      this.calculateTargetWeight();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setFocusToFirstContoller();
    }, 200);
  }
  
  roleCheck(roles: string[]): boolean {
    return roles.some((role) => this.userRoles.includes(role));
  }

  setFocusToFirstContoller(): void {
    if(this.WTypeActive.received) { setTimeout(() => { this.focusContollerById(`asRecived-inHouseId`); }, 0); }

    if(this.WTypeActive.moisture) {
      if (this.modalType == "edit") { setTimeout(() => { this.focusContollerById(`next-button`); }, 0); }
      if (this.modalType == "mswt") { setTimeout(() => { this.focusContollerByQuery(`[formControlName="drySoil"]`); }, 0); }
    }

    if(this.WTypeActive.worksheet) {
      if (this.selectedIndex === 0) { setTimeout(() => { this.focusContollerById(`worksheet-inHouseId`); }, 0); }
      if (this.selectedIndex === 1) { setTimeout(() => { this.focusContollerByQuery(`[formControlName="wetPlusTare"]`); }, 0); }
      if (this.selectedIndex == 2) { setTimeout(() => { this.focusContollerByQuery(`[formControlName="dryPlusTare"]`); }, 0); }
    }
  }

  focusContollerByQuery(selector: string): void {
    const element = document.querySelector(selector) as HTMLElement;
    element?.focus();
  }

  focusContollerById(selector: string): void {
    const element = document.getElementById(selector) as HTMLElement;
    element?.focus();
  }

  onKeyASRWSInHouseIdDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.focusContollerByQuery('[formControlName="mouldPlusProbeTare"]');
    }
  }

  onKeyWSInHouseIdDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.focusContollerByQuery('[formControlName="mouldPlusProbeTare"]');
    }
  }

  onKeyDrySoilDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if(this.nextActive) { this.next(); }
    }
  }

  onKeyMouldPlusProbeTareDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.focusContollerByQuery(`[formControlName="soilDiameter"]`);
    }
  }

  onKeySoilDiameterDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.focusContollerByQuery(`[formControlName="tubeHeight"]`);
    }
  }

  onKeyTubeHeightDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.focusContollerByQuery(`[formControlName="minus"]`);
    }
  }

  onKeyMinusDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if(this.nextActive) { this.next(); }
    }
  }

  onKeyWetPlusTareDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.focusContollerByQuery(`[formControlName="wetTr"]`);
    }
  }

  onKeyWetTrDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if(this.nextActive) { this.next(); }
    }
  }

  onKeyDryPlusTareDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.focusContollerByQuery(`[formControlName="dryTr"]`);
    }
  }

  onKeyDryTrDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if(this.nextActive) { this.next(); }
    }
  }

  private isValid(value: any): boolean {
    return value !== null && value !== '' && value !== 0;
  }
  

  updateTabSelectionBasedOnForm(): void {
    const wetPerLayer = this.form.get('weightPerLayer')?.value;
    const mouldPlusProbeTare = this.form.get('mouldPlusProbeTare')?.value;
    const wetTr = this.form.get('wetTr')?.value;
  
    if (this.isValid(wetPerLayer) && this.isValid(mouldPlusProbeTare)) {
      if (this.isValid(wetTr)) {
          this.selectedIndex = 2;
      } else {
        this.selectedIndex = 1;
      }
    } else {
      this.selectedIndex = 0;
    }
    this.onTabChanged();
  }

  preFillParentMeasurementsData(): void {
    const parentWorkSheet = this.workSheet.parentRow
      ? this.workSheet
      : this.worksheets.find(
          (x) => x.groupId == this.workSheet.groupId && x.parentRow
        );
    
    if(this.workSheet.parentRow) {
      var weightPerLayer = this.form.get('weightPerLayer')
      if(!weightPerLayer?.value || weightPerLayer?.value == 0) {
        weightPerLayer?.setValue(this.weightPerLayerCalc(parentWorkSheet?.labSpecMoistureContent));
      }
      return;
    }
    
    var soilDiameter = this.form.get('soilDiameter');
    if(!soilDiameter?.value || soilDiameter?.value == 0) {
      soilDiameter?.setValue(parentWorkSheet?.soilDiameter);
    }

    var tubeHeight = this.form.get('tubeHeight');
    if(!tubeHeight?.value || tubeHeight?.value == 0) {
      tubeHeight?.setValue(parentWorkSheet?.tubeHeight);
    }
  }

  toNumber(value: any): number | null {
    return value != null && value !== '' ? Number(value) : null;
  }

  onTabChanged() {
    this.setFocusToFirstContoller();
    this.calculateTargetWeight();
  }

  calculateTargetWeight(): void {
    if(this.selectedIndex != 1) { return; }
    var singleTrayWeight = this.toNumber(this.form.controls['weightPerLayer'].value);
    var moldPlusProbe = this.toNumber(this.form.controls['mouldPlusProbeTare'].value);
    if(singleTrayWeight && singleTrayWeight > 0 && moldPlusProbe && moldPlusProbe > 0)
    {
      const parentWorkSheet = this.workSheet.parentRow
      ? this.workSheet
      : this.worksheets.find(
          (x) => x.groupId == this.workSheet.groupId && x.parentRow
        );
      
      var targetWeight = 0
      if(parentWorkSheet?.reUse) {
        var totalNetWeight = singleTrayWeight * 5;
        if(this.workSheet.parentRow)
        {
          targetWeight = totalNetWeight + moldPlusProbe;
        }
        else
        {
          var actualParentWetWeight = parentWorkSheet?.wetPlusTare || 0;
          if (actualParentWetWeight && Number(actualParentWetWeight) > 0) {
            totalNetWeight = Number(actualParentWetWeight) - moldPlusProbe;
          }
          var netDrySoilWeight = totalNetWeight / ( 1 + (Number(parentWorkSheet?.labSpecMoistureContent) / 100));
          targetWeight = netDrySoilWeight * (1 + (Number(this.workSheet?.labSpecMoistureContent) / 100)) + moldPlusProbe;
        }
      } else {
        targetWeight = singleTrayWeight * 5 + moldPlusProbe;
      }
      this.targertWetWeight = Math.round(targetWeight).toString();
    } else {
      this.targertWetWeight = '';
    }
  }

  displayTargetWeight(): boolean {
    if(this.targertWetWeight && Number(this.targertWetWeight) > 0) return true;
    return false;
  }

  getnativeSoilData(): void {
    this.nativeSoilService.getNativeSoilWorkSheetWillAllMoistureSheets(this.projectIdValue).subscribe({
      next: (response: any) => {
        const moistureWorksheets = response?.moistureWorksheets || [];
        this.moistureContentData = moistureWorksheets;
        this.worksheets.forEach((worksheet) => {
          var singleProctorDryDensity = response?.nativeSoilWorksheets.find((x: any) => x.id === worksheet.id)?.singleProctorDryDensity;
          worksheet.singleProctorDryDensity = singleProctorDryDensity;
        });
        this.buildForm();
        this.preFillParentMeasurementsData();
      },
      error: (error) => {
        console.error('Error fetching native soil data:', error);
      },
    });
  }

  closeDialog(): void {
    this.mdr.close(this.actionDone);
  }

  buildForm() {
    if (this.isForm) {
      switch (this.workSheetType) {
        case 'receivedSheet':
          this.buildReceivedForm();
          break;
        case 'moistureWorksheets':
          this.buildMoistureSWTForm();
          break;
        case 'workSheet':
          this.buildWorkSheetForm();
          break;
        case 'proctorWorksheets':
          this.buildProctorForm();
          break;
        default:
      }
      this.patchForm();
    } else {
      this.saveActive = true;
      this.changeDetected = true;
    }
  }

  private setWTypeActive(type: string): void {
    switch (type) {
      case 'receivedSheet':
        this.WTypeActive.received = true;
        break;
      case 'moistureWorksheets':
        this.WTypeActive.moisture = true;
        break;
      case 'workSheet':
        this.WTypeActive.worksheet = true;
        break;
      case 'proctorWorksheets':
        this.WTypeActive.proctor = true;
        break;
      default:
    }
  }

  next(): void {
    const currentTab = this.selectedIndex;
    this.checkInHouseIdValidity();
    this.dryTrCheck = false;
    this.weightChecked = false;
    this.dryPlusTareCheck = false;
    this.previousActive = true;
    this.saveActive = false;
    this.selectedIndex = 0;

    const formvalue = this.form.getRawValue();
    const currentData = { ...this.workSheet };
    if (currentData.collectionDate) {
      currentData.collectionDate = DateTimeUtils.getISODateWithTAndZ(currentData.collectionDate);
    }

    this.currentIndexHandling = '+';
    this.updateData(formvalue, currentData);
    const nextIndex = this.getNextNonReusedIndex(this.currentIndex);
    if (nextIndex !== -1) {
      this.currentIndex = nextIndex;
      this.viewData();
    }

    this.nextActive = this.getNextNonReusedIndex(this.currentIndex) !== -1;

    this.changeDetected = this.form.valid;
    this.inhouseKeyup();
    this.selectedIndex = currentTab;
    this.targertWetWeight = '';
    this.onTabChanged();
  }

  private getNextNonReusedIndex(startIndex: number): number {
    for (let i = startIndex + 1; i < this.worksheets.length; i++) {
      if (!this.worksheets[i]?.reUse) {
        return i;
      }
    }
    return -1;
  }

  prev(): void {
    const currentTab = this.selectedIndex;
    this.checkInHouseIdValidity();
    this.dryTrCheck = false;
    this.weightChecked = false;
    this.dryPlusTareCheck = false;
    this.saveActive = false;
    this.selectedIndex = 0;

    const formvalue = this.form.getRawValue();
    const currentData = this.worksheets[this.currentIndex];
    if (currentData.collectionDate) {
      currentData.collectionDate = DateTimeUtils.getISODateWithTAndZ(currentData.collectionDate);
    }

    this.currentIndexHandling = '-';
    this.updateData(formvalue, currentData);

    const prevIndex = this.getPreviousNonReusedIndex(this.currentIndex);
    if (prevIndex !== -1) {
      this.currentIndex = prevIndex;
      this.viewData();
    }

    var prevValidIndex = this.getPreviousNonReusedIndex(this.currentIndex);
    this.previousActive = prevValidIndex !== -1 && prevValidIndex !== 0;
    this.nextActive = this.getNextNonReusedIndex(this.currentIndex) !== -1;

    this.changeDetected = this.form.valid;
    this.inhouseKeyup();
    this.selectedIndex = currentTab;
    this.targertWetWeight = '';
    this.onTabChanged();
  }

  private getPreviousNonReusedIndex(startIndex: number): number {
    for (let i = startIndex - 1; i >= 0; i--) {
      if (!this.worksheets[i]?.reUse) {
        return i;
      }
    }
    return -1;
  }

  done(): void {
    const formvalue = this.form.getRawValue();
    const currentData = {
      ...this.workSheet,
    };
    if(currentData.collectionDate) {
      currentData.collectionDate = DateTimeUtils.getISODateWithTAndZ(currentData.collectionDate);
    }
    this.updateData(formvalue, currentData);
    if (this.currentIndex <= this.worksheets.length - 1) {
      this.viewData();
    }
    this.changeDetected = this.form.valid;
    this.closeDialog();
  }

  checkForDuplicate(arr: NativeSoilType[], value: string | undefined, id: string | undefined): boolean {
    const duplicate = false;
    arr.forEach((elem: NativeSoilType) => {
    });
    return duplicate;
  }

  checkInHouseIdDuplicate(): void {
    // TODO: make this always false, with new hybrid testing design, review later
    this.inHouseIdDuplicateError = false; return;

    // TODO: Delte this code after testing
    // const enteredId = this.form.value.inHouseId;
    // if (!enteredId) {
    //   this.inHouseIdDuplicateError = false;
    //   return;
    // }
    // const duplicateExists = this.worksheets.some((sheet) =>
    //   sheet.inHouseId === enteredId && sheet.id !== this.workSheet.id
    // );
    // this.inHouseIdDuplicateError = duplicateExists && !this.workSheet.reUse;
  }

  updateHeaderText(type: string): void {
    const startDepth = this.workSheet?.depth ?? '';
    const endDepth = this.workSheet?.endDepth ?? '';
    const displayDepth = `${startDepth}'-${endDepth}'`;
    const hasDisplayDepth = (startDepth || endDepth) !== '';
    switch (type) {
      case 'receivedSheet':
        this.headerText = `Sample ${this.workSheet?.sampleId}${hasDisplayDepth ? ` @ ${displayDepth}` : ''}`;
        break;
      case 'moistureWorksheets':
        const compactionEffortValue = Number(this.workSheet?.compactionEffort);
        const compactionEffortText = compactionEffortValue === 0 ? 'Dump' : `${compactionEffortValue}%`;

        if (this.modalType === 'mswt') {
          this.headerText = `Sample ${this.workSheet?.sampleId}${hasDisplayDepth ? ` @ ${displayDepth}` : ''}, ${compactionEffortText} MDD`;
        } else {
          const mc = this.getFormattedMC(this.workSheet?.moistureContent);
          this.headerText = `Sample ${this.workSheet?.sampleId}${hasDisplayDepth ? ` @ ${displayDepth}` : ''}, ${compactionEffortText} MDD & ${mc} M/C`;
        }
        break;
      case 'workSheet':
        let mc = '';
        if (this.workSheet.worksheetType === 'Bulk') {
          if (this.workSheet?.clientSpecifiedMoistureContent) {
            const m = this.workSheet?.labSpecMoistureContent ?? '0'
            const moistureContent = + m;
            if (moistureContent === 0) {
              mc = this.getFormattedMC(this.workSheet.moistureContent);
            } else if (moistureContent < 0) {
              mc = `(${m})`;
            } else {
              mc = m;
            }
          } else {
            mc = this.getFormattedMC(this.workSheet.moistureContent);
          }
          let effortText = '';
          if (this.workSheet?.effort !== undefined) {
            const effort = +this.workSheet?.effort;
            if (effort === 0) {
              effortText = 'Dump';
            } else if (effort < 0) {
              effortText = `(${effort})`;
            } else {
              effortText = `${effort}%`;
            }
          }
          this.headerText = `Sample ${this.workSheet.sampleId}${hasDisplayDepth ? ` @ ${displayDepth}` : ''}, ${effortText} MDD & ${mc} M/C`;
        } else {
          this.headerText = `Sample ${this.workSheet.sampleId}${hasDisplayDepth ? ` @ ${displayDepth}` : ''}`;
        }
        this.mc = mc;
        break;
      case 'proctorWorksheets':
        if (this.modalType === 'mswt') {
          this.headerText = `Sample ${this.workSheet.sampleId}${hasDisplayDepth ? ` @ ${displayDepth}` : ''}`;
        } else {
          this.headerText = `Sample ${this.workSheet.sampleId}${hasDisplayDepth ? ` @ ${displayDepth}` : ''}, ${this.workSheet.moistureContent} M/C`;
        }
        break;
      default:
    }
  }

  getFormattedMC(value: string): string {
    let mc = '';
    const moistureContent = +value;
    if (moistureContent < 0) {
      mc = `(${value})`;
    } else {
      mc = value;
    }
    return mc;
  }

  getWetPlusTareHeaderString(): string {
    return this.mc ? `Wet + Tare (gm) @ ${this.mc}% M/C`: 'Wet + Tare (gm)';
  }

  save(): void {
    this.checkInHouseIdValidity();
    const formvalue = this.form.getRawValue();
    const currentData = {
      ...this.workSheet,
    };
    if(currentData.collectionDate) {
      currentData.collectionDate = DateTimeUtils.getISODateWithTAndZ(currentData.collectionDate);
    }
    this.currentIndexHandling = '0';
    
    if (this.form.valid) {
      this.updateData(formvalue, currentData);
      this.saveActive = false;
    }
  }

  private updateData(formvalue: any, currentData: any) {
    const payload = this.setPayload(formvalue, currentData);
    if (this.changeDetected) {
        this.actionDone = 'UPDATED';
        if (payload?.depth === '') {
            payload.depth = null;
        }
        if (payload?.endDepth === '') {
            payload.endDepth = null;
        }
        this.callAPI(payload);
        this.changeDetected = false;
    }
}

  private callAPI(payload: any): void {
    if (payload.assignedTo) {
      delete payload.assignedTo;
    }
    switch (this.workSheetType) {
      case 'receivedSheet':
        if (this.receivedSheetCheckForComplete(payload)) {
          payload.status = true;
        } else {
          payload.status = false;
        }
        this.callReceivedWorkSheetAPI(payload);
        break;
      case 'moistureWorksheets':
        if (!this.isForm && this.checkForMoisturesheetsValid(payload)) {
          payload.status = true;
        }
        if (this.modalType === 'mswt') {
          payload.multiPointMoisture = payload.multiPointMoisture.map((obj: any) => obj.moisture);
        }
        this.callMoistureWorkSheetAPI(payload);
        break;
      case 'workSheet':
        if (this.worksheetCheckForComplete(payload)) {
          payload.status = true;
        } else {
          payload.status = false;
        }
        this.callWorkSheetAPI(payload);
        break;
      case 'proctorWorksheets':
        if (this.proctorCheckForComplete(payload)) {
          payload.status = true;
        } else {
          payload.status = false;
        }
        this.callProctorSheetAPI(payload);
        break;
      default:
    }
  }

  callReceivedWorkSheetAPI(payload: ReceivedMCWorkSheet): void {
    this.nativeSoilService.updateReceivedWorkSheet(payload).subscribe({
      next: (response: any) => {
        response.sampleId = payload.sampleId;
        this.setResponseData(response);
      },
      error: () => {},
    });
  }

  callMoistureWorkSheetAPI(payload: MoistureWorkSheet): void {
    this.nativeSoilService.updateMoistureWorkSheet(payload, this.modalType).subscribe({
      next: (response) => {
        response.sampleId = payload.sampleId;
        this.setResponseData(response);
      },
      error: () => {},
    });
  }

  callWorkSheetAPI(payload: WorkSheet): void {
    this.nativeSoilService.updateWorkSheet(payload).subscribe({
      next: (response) => {
        response.sampleId = payload.sampleId;
        this.nativeSoilService.getNativeSoilWorkSheet(this.projectIdValue).subscribe({
          next: (worksheet: any) => {
            const nativeWorksheet = worksheet.nativeSoilWorksheets.filter(
              (element: any) => !element.groupOrder || element.worksheetType === 'Bulk',
            );
            this.worksheets = nativeWorksheet;
            this.setResponseData(response);
            this.calculateTargetWeight();
          },
        });
      },
      error: () => {},
    });
  }

  callProctorSheetAPI(payload: ProctorSheet): void {
    this.nativeSoilService.updateProctorWorkSheet(payload).subscribe({
      next: (response) => {
        response.sampleId = payload.sampleId;
        this.setResponseData(response);
      },
      error: () => {},
    });
  }

  setResponseData(response: any): void {
    switch (this.currentIndexHandling) {
      case '+':
        this.worksheets[this.currentIndex - 1] = response;
        break;
      case '-':
        this.worksheets[this.currentIndex + 1] = response;
        break;
      default:
        this.worksheets[this.currentIndex] = response;
    }
    this.workSheet = this.worksheets[this.currentIndex];
    this.buildForm();
    if (this.WTypeActive.worksheet) this.preFillParentMeasurementsData();
    this.snackBar.open(messagesConfig.generalSubmitSuccessMessage.message, 'DONE', {
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['default-snackbar'],
    });
  }

  private setPayload(form: any, payload: any): any {
    Object.keys(form).forEach((key: any) => {
      payload[key] = form[key];
    });
    return payload;
  }

  private viewData(): void {
    this.workSheet = this.worksheets[this.currentIndex];
    this.updateHeaderText(this.workSheetType);
    this.buildForm();
    if (this.WTypeActive.worksheet) this.preFillParentMeasurementsData();
  }

  buildReceivedForm(): void {
    this.form = new FormGroup({
      inHouseId: new FormControl(this.workSheet?.inHouseId, [Validators.required]),
      wetWeight: new FormControl(this.workSheet?.wetWeight, [Validators.required]),
      dryWeight: new FormControl(this.workSheet?.dryWeight, [Validators.required]),
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.valid) {
        this.changeDetected = true;
        this.saveActive = true;
      } else {
        this.changeDetected = false;
        this.saveActive = false;
      }
    });
  }

  buildMoistureSWTForm(): void {
    this.form = new FormGroup({
      drySoil: new FormControl(this.workSheet.drySoil, [Validators.required]),
      moistureContent: new FormControl(
        {
          value: this.workSheet.moistureContent,
          disabled: true,
        },
        [Validators.required, ValidateOneDecimal()],
      ),
      multiPointMoisture: new FormArray([]),
      reUse: new FormControl(this.workSheet.reUse),
    });
    this.workSheet.multiPointMoisture.forEach((value) => {
      this.addMultiPointMoisture(value);
    });
    this.asReceivedInComplete = Number(this.workSheet.moistureContent) === 0;
    this.form.valueChanges.subscribe(() => {
      if (this.form.valid) {
        this.changeDetected = true;
        this.saveActive = true;
      } else {
        this.changeDetected = false;
        this.saveActive = false;
      }
    });
  }

  get getMultiPointMoisture(): FormArray {
    return this.form?.controls['multiPointMoisture'] as FormArray;
  }

  private createMultiPointMoisture(moisture: string): FormGroup {
    return this.fb.group({
      moisture: [moisture, [Validators.required, ValidateOneDecimal()]],
    });
  }

  addMultiPointMoisture(moisture = ''): void {
    if (this.getMultiPointMoisture.length < 8) {
      this.getMultiPointMoisture.push(this.createMultiPointMoisture(moisture));
    }
  }

  removeMultiPointMoisture() {
    if (this.getMultiPointMoisture.length > 0) {
      this.getMultiPointMoisture.removeAt(this.getMultiPointMoisture.length - 1);
    }
    this.validateMoisture();
  }

  buildWorkSheetForm(): void {
    this.form = new FormGroup({
      inHouseId: new FormControl(
        {
          value: this.workSheet.inHouseId,
          disabled: this.workSheet.reUse && !this.workSheet.parentRow,
        },
        [Validators.required],
      ),
      mouldPlusProbeTare: new FormControl(this.workSheet.mouldPlusProbeTare, [Validators.required]),
      soilDiameter: new FormControl(this.workSheet.soilDiameter, [Validators.required, CustomDecimalValidator()]),
      tubeHeight: new FormControl(this.workSheet.tubeHeight, [Validators.required, CustomDecimalValidator()]),
      minus: new FormControl(this.workSheet.minus, [Validators.required, CustomDecimalValidator()]),
      wetPlusTare: new FormControl(this.workSheet.wetPlusTare, [Validators.required]),
      wetTr: new FormControl(this.workSheet.wetTr, [Validators.required]),
      dryPlusTare: new FormControl(this.workSheet.dryPlusTare, [Validators.required]),
      dryTr: new FormControl(this.workSheet.dryTr, [Validators.required]),
      multiPointTests: new FormArray([]),
      weightPerLayer: new FormControl({
        value: this.workSheet.dump ? null : this.weightPerLayerCalc(),
      }),
    });
    if (this.workSheet.dump) {
      this.form.get('weightPerLayer')?.setValue(null);
    }

    this.form.get('soilDiameter')?.valueChanges.subscribe(() => {
      this.calculateWeightPerLayer();
    });

    this.form.get('tubeHeight')?.valueChanges.subscribe(() => {
      this.calculateWeightPerLayer();
    });

    this.form.get('minus')?.valueChanges.subscribe(() => {
      this.calculateWeightPerLayer();
    });

    this.workSheet.multiPointTests.forEach((value, index) => {
      this.getmultiPointTests.push(this.createMultiPoint());
      this.getmultiPointTests.at(index).patchValue(value);
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.valid) {
        this.changeDetected = true;
        this.saveActive = true;
      } else {
        this.changeDetected = false;
        this.saveActive = false;
      }
    });
  }

  calculateWeightPerLayer() {
    this.form.patchValue({
      weightPerLayer: this.weightPerLayerCalc(),
    });
  }

  weightPerLayerCalc(parentMoisture: string = ''): any {
    if (this.workSheet.dump) {
      return 0;
    }
    const soilDiameter = parseFloat(this.form.get('soilDiameter')?.value) || 0;
    const tubeHeight = parseFloat(this.form.get('tubeHeight')?.value) || 0;
    const minus = parseFloat(this.form.get('minus')?.value) || 0;
    const pi = 3.14159;
    const mouldVolume = ((pi * soilDiameter * soilDiameter) / 4000) * (tubeHeight - minus);
    if(!this.workSheet.clientSpecifiedMoistureContent 
      && !this.workSheet.labSpecMoistureContent && this.workSheet.singleProctorDryDensity) {
        const weightperlayer = ((((Number(this.workSheet.singleProctorDryDensity) * (Number(this.workSheet.effort) / 100)) / 62.4) * mouldVolume) / 5).toFixed(1);
        return weightperlayer
    }
    if (Array.isArray(this.moistureContentData)) {
      const index =  this.moistureContentData.findIndex((x) => 
        (x.nativeSoilSampleId === this.workSheet.nativeSoilSampleId) 
        && x.groupOrder === this.workSheet.groupOrder 
        && x.compactionEffort === this.workSheet.effort 
        && x.depth === this.workSheet.depth)
      if(index > -1) {
        let moisture;    
        const moistireContentSheet = this.moistureContentData[index];
        moisture = parentMoisture ? Number(parentMoisture) : Number(this.workSheet.labSpecMoistureContent);     
        const bulkDensity = moistireContentSheet.proctorDryDensity * (1 + moisture / 100);
        const weightperlayer = ((mouldVolume * bulkDensity * moistireContentSheet.compactionEffort) / 100 / 62.4 / 5).toFixed(1);        
        return weightperlayer;
      }
    }
    return 0;
  }

  createMultiPoint(): FormGroup {
    return this.fb.group({
      wetPlusTare: ['', [Validators.required]],
      wetTr: ['', [Validators.required]],
    });
  }

  get getmultiPointTests(): FormArray {
    return this.form.controls['multiPointTests'] as FormArray;
  }

  addMultiPoint(): void {
    if (this.getmultiPointTests.length < 9) {
      this.getmultiPointTests.push(this.createMultiPoint());
    }
  }

  removeMultiPoint(index: number) {
    this.getmultiPointTests.removeAt(index);
    this.form.markAsDirty();
  }

  buildProctorForm(): void {
    if (this.modalType === 'mswt') {
      this.form = new FormGroup({
        moistureContent: new FormControl(this.workSheet.moistureContent, [Validators.required, ValidateOneDecimal()]),
        drySoil: new FormControl(this.workSheet.drySoil, [Validators.required]),
      });
    } else {
      this.form = new FormGroup({
        mouldAndSoilWeight: new FormControl(this.workSheet.mouldAndSoilWeight, [Validators.required]),
        proctorMouldWeight: new FormControl(this.workSheet.proctorMouldWeight, [Validators.required]),
        proctorMoldDiameter: new FormControl(
          Number(this.workSheet?.proctorMoldDiameter ?? 4),
          [Validators.required]
        ),
      });
    }
    this.form.valueChanges.subscribe(() => {
      if (this.form.valid) {
        this.changeDetected = true;
        this.saveActive = true;
      } else {
        this.changeDetected = false;
        this.saveActive = false;
      }
    });
  }

  patchForm(): void {
    this.form.patchValue(this.workSheet);
  }

  checkForDryWeightValidation(): void {
    let count = 0;
    const dryPlusTare = +this.form.controls['dryPlusTare'].value;
    const wetPlusTare = +this.form.controls['wetPlusTare'].value;
    this.getmultiPointTests.value.forEach((test: any) => {
      if (Number(dryPlusTare) !== 0 && Number(test.wetPlusTare) !== 0) {
        if (Number(dryPlusTare) > Number(test.wetPlusTare) || Number(dryPlusTare) === Number(test.wetPlusTare)) {
          count += 1;
        }
      }
    });
    if (
      count > 0
      || ((Number(dryPlusTare) > Number(wetPlusTare) || Number(dryPlusTare) === Number(wetPlusTare))
        && Number(dryPlusTare) !== 0
        && Number(wetPlusTare) !== 0)
    ) {
      this.changeDetected = false;
      this.dryPlusTareCheck = true;
      this.form.controls['dryPlusTare'].setErrors({
        Invalid: true,
      });
    } else {
      this.dryPlusTareCheck = false;
      this.form.controls['dryPlusTare'].setErrors(null);
    }
    this.form.updateValueAndValidity();
  }

  checkForDryTRValidation(): void {
    let count = 0;
    const dryTr = +this.form.controls['dryTr'].value;
    const wetTr = +this.form.controls['wetTr'].value;
    this.getmultiPointTests.value.forEach((test: any) => {
      if (Number(dryTr) !== 0 && Number(test.wetTr) !== 0) {
        if (Number(dryTr) < Number(test.wetTr) || Number(dryTr) === Number(test.wetTr)) {
          count += 1;
        }
      }
    });
    if (
      count > 0
      || ((Number(dryTr) < Number(wetTr) || Number(dryTr) === Number(wetTr)) && Number(dryTr) !== 0 && Number(wetTr) !== 0)
    ) {
      this.changeDetected = false;
      this.dryTrCheck = true;
      this.form.controls['dryTr'].setErrors({
        Invalid: true,
      });
    } else {
      this.dryTrCheck = false;
      this.form.controls['dryTr'].setErrors(null);
    }
    this.form.updateValueAndValidity();
  }

  checkForWetWightReceived(event: KeyboardEvent, feild: string): void {
    const dryWeight = this.form.controls['dryWeight'].value;
    const wetWeight = this.form.controls['wetWeight'].value;
    if (dryWeight !== 0 && wetWeight !== 0) {
      if (Number(dryWeight) > Number(wetWeight)) {
        this.dryWetWeighterror = true;
        this.form.controls['dryWeight'].setErrors({
          Invalid: true,
        });
      } else {
        this.dryWetWeighterror = false;
        this.form.controls['dryWeight'].setErrors(null);
      }
      this.form.updateValueAndValidity();
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      if(feild == 'WET') {
        this.focusContollerByQuery('[formControlName="dryWeight"]');
      }
      if(feild == 'DRY' && this.nextActive) {
        this.next();
      }
    }
  }

  inhouseKeyup(): void {
    this.checkInHouseIdValidity();
    this.checkInHouseIdDuplicate();
    if (
      this.checkForDuplicate(this.worksheets, this.form.value.inHouseId, this.workSheet.id)
      && !this.workSheet.reUse
    ) {
      this.titleError = true;
    } else {
      this.titleError = false;
    }
  }

  receivedSheetCheckForComplete(payload: ReceivedMCWorkSheet): boolean {
    if (payload.inHouseId !== '' && Number(payload.wetWeight) !== 0 && Number(payload.dryWeight) !== 0) {
      return true;
    }
    return false;
  }

  checkForMoisturesheetsValid(worksheet: NativeSoilType): boolean {
    if (Number(worksheet.drySoil) !== 0 && Number(worksheet.moistureContent) !== 0) {
      return true;
    }
    return false;
  }

  worksheetCheckForComplete(payload: WorkSheet): boolean {
    if (
      payload.inHouseId !== ''
      && Number(payload.mouldPlusProbeTare) !== 0
      && Number(payload.soilDiameter) !== 0
      && Number(payload.tubeHeight) !== 0
      && Number(payload.wetPlusTare) !== 0
      && Number(payload.wetTr) !== 0
      && Number(payload.dryPlusTare) !== 0
      && Number(payload.dryTr) !== 0
    ) {
      return true;
    }
    return false;
  }

  proctorCheckForComplete(payload: ProctorSheet): boolean {
    if (Number(payload.mouldAndSoilWeight) !== 0 && Number(payload.proctorMouldWeight) !== 0) {
      return true;
    }
    return false;
  }

  validateMoisture() {
    let count = 0;
    this.getMultiPointMoisture.controls.forEach((cntrl) => {
      if (
        Number(cntrl.value.moisture) > Number(this.form.get('moistureContent')?.value)
        || Number(cntrl.value.moisture) === Number(this.form.get('moistureContent')?.value)
      ) {
        count += 1;
      }
    });
    this.moistureInValid = count > 0;
  }

  checkForAllValidations() {
    this.checkForDryWeightValidation();
    if (this.workSheet?.worksheetType !== 'Tube') {
      this.checkForWetPlusTareValidation();
    }
  }

  checkForWetPlusTareValidation(): void {
    const wetPlusTare = +this.form.controls['wetPlusTare']?.value || 0;
    this.weightChecked = (this.targertWetWeight && wetPlusTare && Number(this.targertWetWeight) !== wetPlusTare) ? true : false
    this.form.updateValueAndValidity();
  }

  showPopUpMessage(message: IMessage): void {
    const dialogRef = this.dialog.open(MessageModalComponent, {
      panelClass: 'app-dialog',
      data: message,
      disableClose: true,
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '0ms',
    });

    dialogRef.afterClosed().subscribe();
  }

  checkInHouseIdValidity(): void {
    // TODO: make this always false, with new hybrid testing design, review later
    this.inHouseIdDuplicateError = false; return;

    // TODO: Delte this code after testing
    // const enteredId = this.form.value.inHouseId;
    // if (!enteredId) {
    //     this.inHouseIdDuplicateError = false;
    //     return;
    // }

    // let duplicateExists = false;
    // for (let i = 0; i < this.worksheets.length; i++) {
    //     const sheet = this.worksheets[i];
    //     if (sheet.inHouseId === enteredId && sheet.id !== this.workSheet.id) {
    //         duplicateExists = true;
    //         break;
    //     }
    // }

    // this.inHouseIdDuplicateError = duplicateExists && !this.workSheet.reUse;
  }
}
